import { render } from "./FileTypes.vue?vue&type=template&id=3ca5ff20"
import script from "./FileTypes.vue?vue&type=script&lang=js"
export * from "./FileTypes.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__